module.exports = __webpack_public_path__ + "img/L01.6c23ff7a.jpg";